module.exports = __webpack_public_path__ + "img/1_018.839a43e9.jpg";